import React from 'react';
import LinesEllipsis from 'react-lines-ellipsis';

const ElipsisBox = ({ text, maxLine, ...restProps }) => {
  return (
    <LinesEllipsis
      text={text}
      maxLine={maxLine}
      ellipsis='...'
      trimRight
      basedOn='letters'
      {...restProps}
    />
  );
};

export default ElipsisBox;
